import { ChatJson } from "@xflr6/chatbot";
import axios from "axios";

import { SettingsPatch } from "../sharedTypes";
import { baseUrl } from "../utils";
import { HistoryUpdateResponse } from "./sharedTypes";

export interface ChatHistoryResponse {
  identifier: string;
  history: ChatJson | null;
  version: string;
  name: string;
  tName: Record<string, string>;
  // The default language of the chat (or more precisely, of the first flow
  // loaded by the chat). Use this value only if `history` is null, i.e. if
  // `history.language` is not yet available.
  language: string;
  languages: string[];
  updateToken: string;
  settings: SettingsPatch;
}

export async function getManagedChat(
  chatId: string,
  identifier: string
): Promise<ChatHistoryResponse> {
  const _identifier = encodeURIComponent(identifier);
  const response = await axios.get(
    `${baseUrl}/managed_flows/${chatId}?identifier=${_identifier}`
  );
  return response.data;
}

export async function createManagedChat(
  chatId: string,
  identifier?: string | null,
  type?: string | null
): Promise<ChatHistoryResponse> {
  const response = await axios.post(`${baseUrl}/managed_flows/${chatId}`, {
    ...(identifier != null
      ? {
          identifier,
        }
      : {}),
    ...(type != null
      ? {
          // NOTE: origin is hardcoded to aug if any type is passed
          // as that is only case when type would be passed.
          origin: "aug",
        }
      : {}),
  });
  return response.data;
}

export async function getOrCreateManagedChat(
  chatId: string,
  identifier?: string | null,
  type?: string | null
): Promise<ChatHistoryResponse> {
  if (identifier == null) {
    return createManagedChat(chatId, identifier, type);
  } else {
    try {
      // NOTE: Catch won't work without await here
      return await getManagedChat(chatId, identifier);
    } catch (e) {
      if (
        e.response.status === 404 &&
        e.response.data === "Identifier not found"
      ) {
        return createManagedChat(chatId, identifier, type);
      } else {
        throw e;
      }
    }
  }
}

export async function updateManagedChat(
  chatId: string,
  identifier: string,
  history: ChatJson,
  updateToken: string
): Promise<HistoryUpdateResponse> {
  const response = await axios.put(`${baseUrl}/managed_flows/${chatId}`, {
    identifier,
    history,
    updateToken,
  });
  return response.data;
}
